import type { JSX } from 'react';

import { Expander } from './components/Expander';
import type { ExpanderProps } from './components/Expander';
import { PetitionCard } from './components/PetitionCard';
import type { PetitionCardProps } from './components/PetitionCard';

type AdPreviewProps = PetitionCardProps & ExpanderProps;

export function AdPreview({ petition, isSunriseEnabled, ...actions }: AdPreviewProps): JSX.Element {
	return (
		<Expander {...actions} isSunriseEnabled={isSunriseEnabled}>
			<PetitionCard petition={petition} isSunriseEnabled={isSunriseEnabled} />
		</Expander>
	);
}
